export enum AlertReadingStatus {
    READ = "read",
    UNREAD = "unread"
};

export interface UpdateDeviceAlertRequestBody {
    status: AlertReadingStatus,
    timestamp?: string,
    deviceId?: string
};

export interface GetDeviceAlertCountRequestBody {
    startDate: string;
    endDate: string;
    timezone: string;
};